import React from "react";
import TextImageGrid from "../../../components/grids/textImageGrid.component.tsx";
import colors from "../../../constants/colors.ts";
import MainLayout from "../../MainLayout.tsx";
import { imagesFoldersTypes } from "../../../constants/app.constants.ts";

const Section5: React.FC = () => {
  return (
    <MainLayout>
      <TextImageGrid
        backgroundColor={colors.TURQUOISE_81FFFF}
        title={"TITLE.BeneficiiPentruCompanii"}
        text={"TEXT.BeneficiiPentruCompanii"}
        image={'Image-Section'}
        imageVariant={imagesFoldersTypes.PATTERNS}
        alignImage="center"
        hasVerticalPadding={true}
      />
    </MainLayout>
  );
};

export default Section5;
